import { render, staticRenderFns } from "./eventDetailModal.vue?vue&type=template&id=5a60d718&scoped=true"
import script from "./eventDetailModal.vue?vue&type=script&lang=js"
export * from "./eventDetailModal.vue?vue&type=script&lang=js"
import style0 from "./eventDetailModal.vue?vue&type=style&index=0&id=5a60d718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60d718",
  null
  
)

export default component.exports